import { styled, media } from '@styles';

export const Wrapper = styled.div`
  display: grid;
  height: 100%;
  // grid-template-areas: 'sidebar preview';
  // grid-template-columns: 76px 1fr;
  grid-template-rows: 1fr 60px;
  // grid-row-gap: 10px;
  ${media.smallScreen`
    grid-template-rows: 1fr 50px;
  `}
`;

export const Thumbnail = styled.div<{ activeThumbnail: boolean }>`
  width: 50px;
  height: 50px;
  ${media.smallScreen`
    width: 40px;
    height: 40px;
  `}
  display: flex;
  flex-direction: column;
  flex-gap: 10px;
  border-width: 1px;
  border-style: solid;
  border-radius: 10px;
  border-color: ${(props) =>
    props.activeThumbnail === true ? props.theme.colors.red : 'transparent'};

  text-align: center;
  justify-content: center;

  overflow: hidden;

  img {
    width: 100%;
    object-fit: contain;
  }
  svg {
    height: 60%;
    width: 60%;
    object-fit: contain;
  }

  margin: 0.5em 0.25em;
`;

export const Button = styled.div`
  height: 100%;
  width: 20px;
  position: absolute;
  z-index: 10;
  background-color: rgba(50, 50, 50, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const TopButton = styled(Button)`
  left: 0%;

  transform: rotate(180deg);
`;

export const BottomButton = styled(Button)`
  right: 0%;
`;

export const ThumbnailsContainer = styled.div`
  position: relative;
`;

export const ThumbnailList = styled.div`
  position: relative;
  height: 100%;
  overflow-y: hidden;
  overflow-x: scroll;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    height: 0px;
  }
  ul {
    position: absolute;
    display: flex;
    justify-content: center;
    min-width: 100%;
    padding: 0;
    margin: 0;
  }
  li:first-child {
    padding-left: 10px;
  }
  li:last-child {
    padding-right: 10px;
  }
`;

export const Preview = styled.div`
  // grid-area: preview;
  width: auto;
  max-height: 100%;
  overflow: hidden;

  background-color: ${(props) => props.theme.colors.light};

  img {
    width: 100%;
    height: 100%;
    max-height: 100vh;
    object-fit: contain;
  }

  canvas {
    outline: none;
  }
`;
